<template>
    <div class="attr_dialog water-attr">
        <div class="attr_head">
            <el-form ref="form" label-width="100px" class="attr_common" label-position="left" :inline="true">
                <el-form-item label="ID:" class="attr-id">
                    <el-input v-model="curProps.id" type="number"></el-input>
                </el-form-item>

                <el-form-item label="保温方案选择:" v-if="activeTab=='heat_transter'" class="attr-transter">
                    <el-select  v-model="curInsulaScheme" placeholder="保温方案" value-key="id">
                        <el-option
                            v-for="item in insulaSchemeSugs"
                            :key="item.id"
                            :label="item.name"
                            :value="item" @click.native="insulaSchemeSugChange(item)">
                        </el-option>
                    </el-select>
                    <el-button type="primary" @click="newInsulaSchemeSug" size="small" class="new-schemesugs">新建</el-button>
                </el-form-item>

            </el-form>
            <div class="btn-array">
                <el-button type="primary" icon="el-icon-check" size="mini" @click="saveProps">保存</el-button>
                <el-button type="primary" icon="el-icon-close" size="mini" @click="resetProps">恢复默认</el-button>
            </div>
        </div>

        <div class="attr_content">

            <el-tabs v-model="activeTab">
                <el-tab-pane label="管道属性" name="properties" class="properties">

                    <el-form ref="form" :model="curProps" label-width="120px" :inline="true">
                        <el-form-item label="管道内径：" class="attr-item">
                            <el-input v-model="curProps.diameter" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="管道长度：" class="attr-item">
                            <el-input v-model="curProps.length" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="损失系数：" class="attr-item">
                            <el-input v-model="curProps.minorloss" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="粗糙度：" class="attr-item">
                            <el-input v-model="curProps.roughness" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="局部阻力系数：" class="attr-item">
                            <el-input v-model="curProps.localResCoeff" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="壁厚：" class="attr-item">
                            <el-input v-model="curProps.pipeThick" type="number"></el-input>
                        </el-form-item>
                        <el-form-item label="铺设方式：" class="attr-item">
                            <el-radio-group v-model="curProps.layerMethod" class="mode">
                                <el-radio label="架空" value="架空">架空</el-radio>
                                <el-radio label="地埋" value="地埋">地埋</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="初始状态：" class="attr-item">
                            <el-select v-model="curProps.initialdatas" placeholder="请选择初始状态">
                                <el-option label="开启" value="OPEN"></el-option>
                                <el-option label="关闭" value="CLOSE"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>

                </el-tab-pane>

                <!--保温设置-->
                <el-tab-pane label="保温设置" name="heat_transter" class="heat_transter">

                    <el-form ref="form" label-width="100px" class="attr_form" :inline="true" label-position="left" v-if="curInsulaScheme">
                        <el-form-item label="保温层数:">
                            <el-input v-model="curInsulaScheme.insulaNumber" type="number" :disabled="true"></el-input>
                        </el-form-item>
                    </el-form>

                    <!--保温设置-->
                    <el-table
                        :data="curInsulaScheme.insulaScheme"
                        border
                        style="width: 100%"
                        class="custom-table"
                        row-class-name="custom-row"
                        header-row-class-name="custom-header"
                        cell-class-name="custom-cell">
                        <el-table-column
                            prop="name"
                            label="保温层数"
                            width="120">
                        </el-table-column>

                        <el-table-column
                            label="保温材料">
                            <template slot-scope="scope">
                                <span>{{insulaMaterial[scope.row.insulaMaterialId].name}}</span>
                            </template>
                        </el-table-column>

                        <el-table-column
                            prop="insulaThick"
                            label="保温厚度"
                            width="120">
                        </el-table-column>
                    </el-table>


                </el-tab-pane>
            </el-tabs>         
        </div>

        <!--新建保温方案信息框-->
        <el-dialog
            :visible.sync="setting_dialog"
            :append-to-body="true"
            :modal="false"
            custom-class="setting-dialog"
            :close-on-click-modal="false"
            v-drag>
            <span slot="title">保温方案预设</span>
            <InsulaSchemeSet class ="setting-content" v-if="setting_dialog" @close="setting_dialog=false"/>
        </el-dialog>
    </div>
</template>

<script>
/**
 * 保温水管道的属性编辑框
 */
import { mapState } from 'vuex';
import _find from 'lodash/find'

export default {
    name:"waterline",
    components:{
        InsulaSchemeSet:()=>import('./InsulaSchemeSet.vue'), // 保温方案设置
    },
    computed:{
        ...mapState('simulation',[
            'drawSource',
            'globalConfig', // 全局配置
        ]),
        // 当前选中的Feature
        curFeature(){
            return this.$store.state.simulation.curFeatures[0];
        },
    },
     data(){
        return {
            activeTab:"properties", // 显示面板

            curProps:{
                id:0,
                length:0.0, // 管道长度
                diameter:0.0,// 管道内径
                roughness:0.0, // 粗糙度
                minorloss:0.0, // 损失系数
                initialdatas:"OPEN", // 初始状态
                localResCoeff:0.0, // 局部阻力系数

                pipeThick:0.0, // 壁厚
                layerMethod:"地埋", // 铺设方式
                insulaSchemeId:0, // 保温方案id
            } , // 当前属性

            curInsulaScheme:{} ,// 当前选中的保温方案
            insulaSchemeSugs:[], // 保温方案列表
            insulaMaterial:{}, // 保温材料
            setting_dialog:false, // 保温方案设置对话框
        }
    },
    mounted(){
        // 初始化属性
        this.$nextTick(()=>{
            this.init_props()
        })
    },
    methods:{
        // 初始化属性
        init_props(){
            let nodeProps=this.curFeature?this.curFeature.getProperties():{};
            let props={};

            // 替换默认属性
            let defaultValue=this.$store.getters['simulation/getDefault']("insulationWater");
            props=Object.assign({},defaultValue,nodeProps);
            
            // 构建保温方案
            let insulaSchemeId=props.insulaSchemeId;
            let insulaSchemeSugs=this.globalConfig.insulaSchemeSugs;
            this.insulaSchemeSugs=insulaSchemeSugs;
            let curInsulaScheme=_find(insulaSchemeSugs,function(o){return o.id==insulaSchemeId});
            if(curInsulaScheme){
                this.curInsulaScheme=curInsulaScheme;
            }
            // 保温材料
            let insulaMaterialSugs=this.globalConfig.insulaMaterialSugs;
            for(let item of insulaMaterialSugs){
                let id=item.id;
                this.insulaMaterial[id]=item;
            }
            // 保存当前属性
            this.curProps=props;
        },
        // 保温方案选中改变
        insulaSchemeSugChange(item){
            this.curInsulaScheme=item;
        },
        // 保存修改的属性
        saveProps(){
            let nodeProps=this.curFeature?this.curFeature.getProperties():{};
            // 修改id号  
            let id=this.curProps.id;
            if(this.checkId(id)){
                this.$message({
                    message:"编号已存在",
                    type:"error",
                    duration:2000
                });
                return;
            }
            // 保温方案
            let insulaSchemeId=this.curInsulaScheme.insulaSchemeId;
            this.curProps.insulaSchemeId=insulaSchemeId;
            // 重新应用属性
            let temp=Object.assign({},nodeProps,this.curProps);
            this.curFeature.setProperties(temp);
            // 弹出提示框，提示保存成功
            this.$message({
                message:"保存成功",
                type:"success",
                duration:2000
            });

            // 关闭对话框
            this.$emit("close");

        },
        // 重置属性
        resetProps(){
            // 重新获取属性
            this.init_props();
        },
        // id号判断
        checkId(id){
            let source=this.drawSource;
            let features=source.getFeatures();
            let result=false;
            features.forEach(f=>{
                let _type=f.get("_type");
                // 判断当前图形是不是管道
                if(_type=="line"){
                    let nodeid=f.get("id");
                    if(nodeid==id&&this.curFeature!=f){
                        result=true;
                        return;
                    }
                }
            });
            return result;
        },
        // 新建保温方案
        newInsulaSchemeSug(){
            this.setting_dialog=true;
        }
    }
}
</script>

<style lang="scss" scoped>
.water-attr{
    position: relative;
    width:720px;

    .attr_head{
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;

        .attr_common{
            flex:1;
            display: flex;
            flex-wrap: wrap;

            ::v-deep .el-form-item{
                margin-right: 0;
                width: 50%;
                margin-bottom: 5px;
            }
            ::v-deep .el-form-item:nth-child(even){
                padding-left: 30px;
            }

            ::v-deep .el-input{
                width:150px;
            }

            .attr-id{
                width:40%;
            }
            .attr-transter{
                width: 60%;

                .new-schemesugs{
                    margin-left: 10px;
                }
            }
        }

        .btn-array{
            position:relative;
            float:right;

            button{
                display: block;
                margin-top: 8px;
                margin-left: 0;
                padding: 5px 3px;
                width: 90px;
                span{
                    cursor: pointer;
                }
            }

            button:first-child{
                margin-top:0;
            }
        }

        ::v-deep .el-input__inner{
            line-height: 35px;
            height: 35px;
        }
    }

    ::v-deep .attr_content{
        height: 460px;
        border: 1px solid #246bc640;
        border-radius: 4px;
        margin-top: 10px;
        overflow-x:hidden ;
        padding: 0 5px;

        .el-form{
            display: flex;
            flex-wrap: wrap;
        }

        .attr-item{
            margin-top: 5px;
            margin-right: 0;
            flex: 1 0 50%;

            span{
                font-size: 18px;
            }

            .el-input{
                width: 150px;

                input{
                    height: 30px;
                    line-height: 30px;
                }

            }
            .el-select{
                width: 150px;
            }

            .attr_unit{
                margin-left: 10px;
            }
        }
    }
}
</style>